/**
 * ViewAsBanner shows at top of /me when admin is impersonating a user.
 * Fetches "viewing as {name}" copy from copy_registry. "Exit" terminates the view-as session.
 */
import { useEffect, useState } from "react";
import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function ViewAsBanner() {
  const navigate = useNavigate();
  const [vaInfo, setVaInfo] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("phygital_view_as");
      if (raw) setVaInfo(JSON.parse(raw));
    } catch {}
  }, []);

  if (!vaInfo) return null;

  const exit = () => {
    localStorage.removeItem("session_token");
    localStorage.removeItem("phygital_view_as");
    document.cookie = "session_token=; max-age=0; path=/";
    navigate("/admin");
    window.location.reload();
  };

  return (
    <div className="sticky top-0 z-50 bg-amber-100 border-b border-amber-300 px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2 text-amber-900 text-sm">
        <Eye className="w-4 h-4" />
        <span>Viewing as <strong>{vaInfo.display_name}</strong> (admin preview)</span>
      </div>
      <Button size="sm" variant="ghost" onClick={exit} className="text-amber-900 hover:bg-amber-200" data-testid="view-as-exit-btn">
        <X className="w-4 h-4 mr-1" /> Exit
      </Button>
    </div>
  );
}
